import type { DealOffer } from "@/components/marketplace/deal-offers-types";

/** Sort displayed item prices without adding shipping. Unpriced offers come last. */
export function sortOffersByItemPrice<T extends Pick<DealOffer, "currentPrice">>(offers: T[]): T[] {
  return [...offers].sort((left, right) => {
    const leftPrice = left.currentPrice === null ? Infinity : Number(left.currentPrice);
    const rightPrice = right.currentPrice === null ? Infinity : Number(right.currentPrice);
    const validLeft = Number.isFinite(leftPrice) ? leftPrice : Infinity;
    const validRight = Number.isFinite(rightPrice) ? rightPrice : Infinity;
    return validLeft === validRight ? 0 : validLeft - validRight;
  });
}
